module.exports = __webpack_public_path__ + "static/media/soft-fit-cereja-trans.26634dcc.webp";